import React, { useEffect, useMemo, useState } from "react";
import Button from "../Components/Button";
import logo from "../wyllie-home.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router";
import { AdminAuthService } from "../services/adminAuthService";
import {
  AUTH_SESSION_CHANGED_EVENT,
  isLoggedIn,
} from "../services/authSession";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {};

export default function LaunchPad({}: Props) {
  const [authed, setAuthed] = useState(isLoggedIn());
  const authService = useMemo(() => new AdminAuthService(), []);
  const navigate = useNavigate();

  useEffect(() => {
    const refresh = () => setAuthed(isLoggedIn());
    window.addEventListener(AUTH_SESSION_CHANGED_EVENT, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(AUTH_SESSION_CHANGED_EVENT, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  return (
    <div className="launch-pad d-flex flex-column">
      <img src={logo} className="App-logo mb-0" alt="logo" />
      {!authed && (
        <Button
          className="primary-button p-3 mt-1"
          onClick={() => navigate("/login")}
        >
          Sign In
        </Button>
      )}
      <Button
        className="primary-button p-3 mt-5"
        onClick={() => navigate("/home-hub")}
      >
        Display
      </Button>
      <Button
        className="secondary-button p-3 mt-3"
        onClick={() => navigate("/admin")}
      >
        Admin
      </Button>
      {authed && (
        <Button
          className="danger-button p-3 mt-3"
          onClick={() => authService.logout()}
        >
          Sign Out
        </Button>
      )}
    </div>
  );
}
